import * as React from "react";

import { cn } from "@bcc/lib/utils";
import {
  setCardTestId,
  setCardHeaderTestId,
  setCardTitleTestId,
  setCardDescriptionTestId,
  setCardActionTestId,
  setCardContentTestId,
  setCardFooterTestId,
} from "./card.utils";

function Card({ className, testId, ...props }: React.ComponentProps<"div"> & { testId?: string }) {
  return (
    <div
      data-slot="card"
      data-testid={testId ?? setCardTestId("card")}
      className={cn("bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm", className)}
      {...props}
    />
  );
}

function CardHeader({ className, testId, ...props }: React.ComponentProps<"div"> & { testId?: string }) {
  return (
    <div
      data-slot="card-header"
      data-testid={testId ?? setCardHeaderTestId("card")}
      className={cn(
        "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-2 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
        className
      )}
      {...props}
    />
  );
}

function CardTitle({ className, testId, ...props }: React.ComponentProps<"div"> & { testId?: string }) {
  return (
    <div
      data-slot="card-title"
      data-testid={testId ?? setCardTitleTestId("card")}
      className={cn("leading-none font-semibold", className)}
      {...props}
    />
  );
}

function CardDescription({ className, testId, ...props }: React.ComponentProps<"div"> & { testId?: string }) {
  return (
    <div
      data-slot="card-description"
      data-testid={testId ?? setCardDescriptionTestId("card")}
      className={cn("text-muted-foreground text-sm", className)}
      {...props}
    />
  );
}

function CardAction({ className, testId, ...props }: React.ComponentProps<"div"> & { testId?: string }) {
  return (
    <div
      data-slot="card-action"
      data-testid={testId ?? setCardActionTestId("card")}
      className={cn("col-start-2 row-span-2 row-start-1 self-start justify-self-end", className)}
      {...props}
    />
  );
}

function CardContent({ className, testId, ...props }: React.ComponentProps<"div"> & { testId?: string }) {
  return <div data-slot="card-content" data-testid={testId ?? setCardContentTestId("card")} className={cn("px-6", className)} {...props} />;
}

function CardFooter({ className, testId, ...props }: React.ComponentProps<"div"> & { testId?: string }) {
  return (
    <div
      data-slot="card-footer"
      data-testid={testId ?? setCardFooterTestId("card")}
      className={cn("flex items-center px-6 [.border-t]:pt-6", className)}
      {...props}
    />
  );
}

export { Card, CardHeader, CardFooter, CardTitle, CardAction, CardDescription, CardContent };
